export const previewRebate = (amount, tiers = []) => {
  const value = Number(amount);
  const tier = tiers.find((item) => value >= Number(item.minAmount) && (item.maxAmount === null || value <= Number(item.maxAmount)));
  return tier ? Math.floor(value * Number(tier.rate)) : 0;
};

export const percentToBps = (value) => {
  const percent = Number(value);
  if (!Number.isFinite(percent) || percent < 0 || percent > 100) return NaN;
  const scaled = percent * 100;
  if (Math.abs(scaled - Math.round(scaled)) > 1e-8) return NaN;
  return Math.round(scaled);
};

export const bpsToPercent = (value) => {
  const bps = Number(value);
  return Number.isFinite(bps) ? bps / 100 : 0;
};

export const previewInviteRewards = (actualTopupAmount, invite = {}) => {
  const amount = Math.max(Number(actualTopupAmount) || 0, 0);
  const cap = invite.rewardCapIdr === null || invite.rewardCapIdr === undefined
    ? null
    : Math.max(Number(invite.rewardCapIdr) || 0, 0);
  const applyCap = (reward) => cap === null ? reward : Math.min(reward, cap);
  return {
    referrer: applyCap(Math.floor(amount * (Number(invite.referrerRateBps) || 0) / 10000)),
    invitee: applyCap(Math.floor(amount * (Number(invite.inviteeRateBps) || 0) / 10000))
  };
};

export const toPercentageGrowthDraft = (source = {}) => {
  const value = JSON.parse(JSON.stringify(source || {}));
  const isPercentageSource = Number(value.schemaVersion) === 2;
  value.schemaVersion = 2;
  value.invite = {
    enabled: value.invite?.enabled !== false,
    rewardMode: 'PERCENTAGE',
    basis: 'ACTUAL_TOPUP_AMOUNT',
    referrerRateBps: isPercentageSource ? Number(value.invite?.referrerRateBps || 0) : 0,
    inviteeRateBps: isPercentageSource ? Number(value.invite?.inviteeRateBps || 0) : 0,
    rewardCapIdr: isPercentageSource && value.invite?.rewardCapIdr !== undefined
      ? value.invite.rewardCapIdr
      : null,
    trigger: 'FIRST_ELIGIBLE_TOPUP'
  };
  const waterReward = value.water20Plus1 || {};
  value.water20Plus1 = {
    enabled: Boolean(waterReward.enabled),
    thresholdLiters: Number(waterReward.thresholdLiters || 380),
    rewardLiters: Number(waterReward.rewardLiters || 19),
    eligibleWaterTypes: Array.isArray(waterReward.eligibleWaterTypes)
      ? [...waterReward.eligibleWaterTypes]
      : ['mineral', 'pure'],
    accumulationMode: waterReward.accumulationMode || 'LIFETIME_PER_WATER_TYPE',
    rewardPricing: waterReward.rewardPricing || 'QUALIFYING_BLOCK_AVERAGE_PRICE',
    fundingBasis: waterReward.fundingBasis || 'FINANCE_ELIGIBLE_ALLOCATIONS'
  };
  return value;
};

export const validateGrowthProgram = (config) => {
  const inviteValues = Number(config.schemaVersion) === 2
    ? [config.invite?.referrerRateBps, config.invite?.inviteeRateBps]
    : [config.invite?.referrerAmount, config.invite?.inviteeAmount];
  const nonNegative = [config.signup?.amount, ...inviteValues]
    .every((value) => Number.isFinite(Number(value)) && Number(value) >= 0);
  if (!nonNegative) return { valid: false, code: 'NEGATIVE_AMOUNT' };
  if (Number(config.schemaVersion) === 2) {
    const validPercentageMode = config.invite?.rewardMode === 'PERCENTAGE'
      && config.invite?.basis === 'ACTUAL_TOPUP_AMOUNT';
    const validRates = inviteValues.every((value) => Number.isInteger(Number(value)) && Number(value) <= 10000);
    const cap = config.invite?.rewardCapIdr;
    const validCap = cap === null || cap === undefined
      || (Number.isSafeInteger(Number(cap)) && Number(cap) >= 0 && Number(cap) <= 999999999999);
    if (!validPercentageMode || !validRates) return { valid: false, code: 'INVALID_INVITE_RATE' };
    if (!validCap) return { valid: false, code: 'INVALID_REWARD_CAP' };
  }
  const tiers = config.rebate?.tiers || [];
  if (!tiers.length) return { valid: false, code: 'MISSING_TIERS' };
  for (let index = 0; index < tiers.length; index += 1) {
    const tier = tiers[index];
    if (Number(tier.rate) < 0 || Number(tier.rate) > 1) return { valid: false, code: 'INVALID_RATE' };
    if (index && Number(tiers[index - 1].maxAmount) + 1 !== Number(tier.minAmount)) return { valid: false, code: 'TIER_GAP' };
    if (index < tiers.length - 1 && tier.maxAmount === null) return { valid: false, code: 'TIER_OVERLAP' };
  }
  if (tiers[tiers.length - 1].maxAmount !== null) return { valid: false, code: 'FINAL_TIER_CLOSED' };
  if (new Date(config.effectiveAt).getTime() <= Date.now()) return { valid: false, code: 'EFFECTIVE_TIME' };
  return { valid: true };
};
